"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var IconSymbol;
(function (IconSymbol) {
    IconSymbol["AddCell"] = "add-cell";
    IconSymbol["AddColumn"] = "add-column";
    IconSymbol["AddRole"] = "add-role";
    IconSymbol["AddRow"] = "add-row";
    IconSymbol["Adjust"] = "adjust";
    IconSymbol["Ai"] = "ai";
    IconSymbol["AiSimple"] = "ai-simple";
    IconSymbol["AlignCenter"] = "align-center";
    IconSymbol["AlignImageCenter"] = "align-image-center";
    IconSymbol["AlignImageFullWidth"] = "align-image-full-width";
    IconSymbol["AlignImageLeft"] = "align-image-left";
    IconSymbol["AlignImageRight"] = "align-image-right";
    IconSymbol["AlignJustify"] = "align-justify";
    IconSymbol["AlignLeft"] = "align-left";
    IconSymbol["AlignRight"] = "align-right";
    IconSymbol["Analytics"] = "analytics";
    IconSymbol["AngleDown"] = "angle-down";
    IconSymbol["AngleDownSmall"] = "angle-down-small";
    IconSymbol["AngleLeft"] = "angle-left";
    IconSymbol["AngleLeftSmall"] = "angle-left-small";
    IconSymbol["AngleRight"] = "angle-right";
    IconSymbol["AngleRightSmall"] = "angle-right-small";
    IconSymbol["AngleUp"] = "angle-up";
    IconSymbol["AngleUpSmall"] = "angle-up-small";
    IconSymbol["Announcement"] = "announcement";
    IconSymbol["Anonymize"] = "anonymize";
    IconSymbol["ApiLock"] = "api-lock";
    IconSymbol["ApiWeb"] = "api-web";
    IconSymbol["Archive"] = "archive";
    IconSymbol["ArrowEnd"] = "arrow-end";
    IconSymbol["ArrowFirst"] = "arrow-first";
    IconSymbol["ArrowJoin"] = "arrow-join";
    IconSymbol["ArrowLast"] = "arrow-last";
    IconSymbol["ArrowRightFull"] = "arrow-right-full";
    IconSymbol["ArrowSplit"] = "arrow-split";
    IconSymbol["ArrowStart"] = "arrow-start";
    IconSymbol["ArrowUpFull"] = "arrow-up-full";
    IconSymbol["ArrowXor"] = "arrow-xor";
    IconSymbol["Asterisk"] = "asterisk";
    IconSymbol["Audio"] = "audio";
    IconSymbol["AutomaticTranslate"] = "automatic-translate";
    IconSymbol["Autosize"] = "autosize";
    IconSymbol["BackgroundColor"] = "background-color";
    IconSymbol["Bars"] = "bars";
    IconSymbol["BellFull"] = "bell-full";
    IconSymbol["BellOff"] = "bell-off";
    IconSymbol["BellOn"] = "bell-on";
    IconSymbol["BellOnFull"] = "bell-on-full";
    IconSymbol["Block"] = "block";
    IconSymbol["Blogs"] = "blogs";
    IconSymbol["Bold"] = "bold";
    IconSymbol["Bolt"] = "bolt";
    IconSymbol["Bookmarks"] = "bookmarks";
    IconSymbol["Books"] = "books";
    IconSymbol["BoxContainer"] = "box-container";
    IconSymbol["Breadcrumb"] = "breadcrumb";
    IconSymbol["Briefcase"] = "briefcase";
    IconSymbol["Button"] = "button";
    IconSymbol["Calendar"] = "calendar";
    IconSymbol["Camera"] = "camera";
    IconSymbol["Cards"] = "cards";
    IconSymbol["Cards2"] = "cards2";
    IconSymbol["CardsFull"] = "cards-full";
    IconSymbol["CaretBottom"] = "caret-bottom";
    IconSymbol["CaretBottomL"] = "caret-bottom-l";
    IconSymbol["CaretDouble"] = "caret-double";
    IconSymbol["CaretDoubleL"] = "caret-double-l";
    IconSymbol["CaretLeft"] = "caret-left";
    IconSymbol["CaretLeftL"] = "caret-left-l";
    IconSymbol["CaretRight"] = "caret-right";
    IconSymbol["CaretRightL"] = "caret-right-l";
    IconSymbol["CaretTop"] = "caret-top";
    IconSymbol["CaretTopL"] = "caret-top-l";
    IconSymbol["Catalog"] = "catalog";
    IconSymbol["Categories"] = "categories";
    IconSymbol["ChainBroken"] = "chain-broken";
    IconSymbol["Change"] = "change";
    IconSymbol["ChangeList"] = "change-list";
    IconSymbol["ChangeListDisabled"] = "change-list-disabled";
    IconSymbol["Chatbot"] = "chatbot";
    IconSymbol["Check"] = "check";
    IconSymbol["Checkbox"] = "checkbox";
    IconSymbol["CheckboxEmpty"] = "checkbox-empty";
    IconSymbol["CheckCircle"] = "check-circle";
    IconSymbol["CheckCircleFull"] = "check-circle-full";
    IconSymbol["CheckSmall"] = "check-small";
    IconSymbol["CheckSquare"] = "check-square";
    IconSymbol["Chip"] = "chip";
    IconSymbol["Circle"] = "circle";
    IconSymbol["CloseAllCollapse"] = "close-all-collapse";
    IconSymbol["ClosedBook"] = "closed-book";
    IconSymbol["Cloud"] = "cloud";
    IconSymbol["Code"] = "code";
    IconSymbol["Cog"] = "cog";
    IconSymbol["ColorPicker"] = "color-picker";
    IconSymbol["Columns"] = "columns";
    IconSymbol["Comments"] = "comments";
    IconSymbol["Community"] = "community";
    IconSymbol["Compress"] = "compress";
    IconSymbol["Container"] = "container";
    IconSymbol["ControlPanel"] = "control-panel";
    IconSymbol["Copy"] = "copy";
    IconSymbol["CreditCard"] = "credit-card";
    IconSymbol["Cursor"] = "cursor";
    IconSymbol["Custom"] = "custom";
    IconSymbol["CustomField"] = "custom-field";
    IconSymbol["CustomSize"] = "custom-size";
    IconSymbol["Cut"] = "cut";
    IconSymbol["Date"] = "date";
    IconSymbol["Decimal"] = "decimal";
    IconSymbol["Desktop"] = "desktop";
    IconSymbol["DeviceCheck"] = "device-check";
    IconSymbol["Devices"] = "devices";
    IconSymbol["Diagram"] = "diagram";
    IconSymbol["Diamond"] = "diamond";
    IconSymbol["Diary"] = "diary";
    IconSymbol["Disk"] = "disk";
    IconSymbol["Display"] = "display";
    IconSymbol["DisplayContent"] = "display-content";
    IconSymbol["Document"] = "document";
    IconSymbol["DocumentCode"] = "document-code";
    IconSymbol["DocumentCompressed"] = "document-compressed";
    IconSymbol["DocumentDefault"] = "document-default";
    IconSymbol["DocumentImage"] = "document-image";
    IconSymbol["DocumentMultimedia"] = "document-multimedia";
    IconSymbol["DocumentPdf"] = "document-pdf";
    IconSymbol["DocumentPending"] = "document-pending";
    IconSymbol["DocumentPresentation"] = "document-presentation";
    IconSymbol["DocumentsAndMedia"] = "documents-and-media";
    IconSymbol["DocumentTable"] = "document-table";
    IconSymbol["DocumentText"] = "document-text";
    IconSymbol["DocumentVector"] = "document-vector";
    IconSymbol["Download"] = "download";
    IconSymbol["Drag"] = "drag";
    IconSymbol["Drop"] = "drop";
    IconSymbol["Dropdown"] = "dropdown";
    IconSymbol["DynamicDataList"] = "dynamic-data-list";
    IconSymbol["DynamicDataMapping"] = "dynamic-data-mapping";
    IconSymbol["EditLayout"] = "edit-layout";
    IconSymbol["Effects"] = "effects";
    IconSymbol["EllipsisH"] = "ellipsis-h";
    IconSymbol["EllipsisV"] = "ellipsis-v";
    IconSymbol["Embed"] = "embed";
    IconSymbol["Emoji"] = "emoji";
    IconSymbol["EnvelopeClosed"] = "envelope-closed";
    IconSymbol["EnvelopeOpen"] = "envelope-open";
    IconSymbol["Environment"] = "environment";
    IconSymbol["EnvironmentConnected"] = "environment-connected";
    IconSymbol["EnvironmentDisconnected"] = "environment-disconnected";
    IconSymbol["ExclamationCircle"] = "exclamation-circle";
    IconSymbol["ExclamationFull"] = "exclamation-full";
    IconSymbol["Expand"] = "expand";
    IconSymbol["Fieldset"] = "fieldset";
    IconSymbol["FileScript"] = "file-script";
    IconSymbol["FileTemplate"] = "file-template";
    IconSymbol["FileXsl"] = "file-xsl";
    IconSymbol["Filter"] = "filter";
    IconSymbol["Fire"] = "fire";
    IconSymbol["FlagEmpty"] = "flag-empty";
    IconSymbol["FlagFull"] = "flag-full";
    IconSymbol["Folder"] = "folder";
    IconSymbol["Format"] = "format";
    IconSymbol["FormExtensions"] = "form-extensions";
    IconSymbol["Forms"] = "forms";
    IconSymbol["FullSize"] = "full-size";
    IconSymbol["Geolocation"] = "geolocation";
    IconSymbol["Globe"] = "globe";
    IconSymbol["Google"] = "google";
    IconSymbol["GoogleDrive"] = "google-drive";
    IconSymbol["Grid"] = "grid";
    IconSymbol["H1"] = "h1";
    IconSymbol["H2"] = "h2";
    IconSymbol["Hashtag"] = "hashtag";
    IconSymbol["Hdd"] = "hdd";
    IconSymbol["Heart"] = "heart";
    IconSymbol["HeartFull"] = "heart-full";
    IconSymbol["Hidden"] = "hidden";
    IconSymbol["Home"] = "home";
    IconSymbol["HomeFull"] = "home-full";
    IconSymbol["HorizontalScroll"] = "horizontal-scroll";
    IconSymbol["Hr"] = "hr";
    IconSymbol["Import"] = "import";
    IconSymbol["ImportExport"] = "import-export";
    IconSymbol["ImportList"] = "import-list";
    IconSymbol["IndentLess"] = "indent-less";
    IconSymbol["IndentMore"] = "indent-more";
    IconSymbol["InfoBook"] = "info-book";
    IconSymbol["InfoCircle"] = "info-circle";
    IconSymbol["InfoCircleOpen"] = "info-circle-open";
    IconSymbol["InfoPanelClosed"] = "info-panel-closed";
    IconSymbol["InfoPanelOpen"] = "info-panel-open";
    IconSymbol["InformationLive"] = "information-live";
    IconSymbol["Integer"] = "integer";
    IconSymbol["Italic"] = "italic";
    IconSymbol["KnowArchive"] = "know-archive";
    IconSymbol["KnowArrowBack"] = "know-arrow-back";
    IconSymbol["KnowArrowNext"] = "know-arrow-next";
    IconSymbol["KnowBurger"] = "know-burger";
    IconSymbol["BusinessScheme"] = "business-scheme";
    IconSymbol["BusinessProcess"] = "business-process";
    IconSymbol["KnowChevronDown"] = "know-chevron-down";
    IconSymbol["KnowChevronUp"] = "know-chevron-up";
    IconSymbol["KnowCloseSmall"] = "know-close-small";
    IconSymbol["KnowCloseBig"] = "know-close-big";
    IconSymbol["DocumentBRD"] = "document-brd";
    IconSymbol["DocumentFSD"] = "document-fsd";
    IconSymbol["DocumentPRD"] = "document-prd";
    IconSymbol["DocumentCR"] = "document-cr";
    IconSymbol["KnowDraft"] = "know-draft";
    IconSymbol["KnowDynamicLink"] = "know-dynamic-link";
    IconSymbol["KnowEmptyPage"] = "know-empty-page";
    IconSymbol["KnowFilterAdd"] = "know-filter-add";
    IconSymbol["Handbag"] = "handbag";
    IconSymbol["KnowLogin"] = "know-login";
    IconSymbol["KnowLogout"] = "know-logout";
    IconSymbol["KnowMail"] = "know-mail";
    IconSymbol["KnowMessage"] = "know-message";
    IconSymbol["KnowNotifications"] = "know-notifications";
    IconSymbol["KnowOrderFormCog"] = "know-order-form-cog";
    IconSymbol["KnowPlus"] = "know-plus";
    IconSymbol["KnowResize"] = "know-resize";
    IconSymbol["RocketTakeoff"] = "rocket-takeoff";
    IconSymbol["KnowRollup"] = "know-rollup";
    IconSymbol["KnowStar"] = "know-star";
    IconSymbol["KnowStarColor"] = "know-star-color";
    IconSymbol["KnowUpsize"] = "know-upsize";
    IconSymbol["KnowVerticalDots"] = "know-vertical-dots";
    IconSymbol["KnowWebPage"] = "know-web-page";
    IconSymbol["Script"] = "script";
    IconSymbol["LiferayAc"] = "liferay-ac";
    IconSymbol["Link"] = "link";
    IconSymbol["List"] = "list";
    IconSymbol["ListOl"] = "list-ol";
    IconSymbol["ListOlRtl"] = "list-ol-rtl";
    IconSymbol["ListUl"] = "list-ul";
    IconSymbol["ListUlRtl"] = "list-ul-rtl";
    IconSymbol["Live"] = "live";
    IconSymbol["LocaleArSa"] = "ar-sa";
    IconSymbol["LocaleBgBg"] = "bg-bg";
    IconSymbol["LocaleCaAd"] = "ca-ad";
    IconSymbol["LocaleCaEs"] = "ca-es";
    IconSymbol["LocaleCsCz"] = "cs-cz";
    IconSymbol["LocaleDaDk"] = "da-dk";
    IconSymbol["LocaleDeDe"] = "de-de";
    IconSymbol["LocaleElGr"] = "el-gr";
    IconSymbol["LocaleEnAu"] = "en-au";
    IconSymbol["LocaleEnGb"] = "en-gb";
    IconSymbol["LocaleEnUs"] = "en-us";
    IconSymbol["LocaleEsEs"] = "es-es";
    IconSymbol["LocaleEtEe"] = "et-ee";
    IconSymbol["LocaleEuEs"] = "eu-es";
    IconSymbol["LocaleFaIr"] = "fa-ir";
    IconSymbol["LocaleFiFi"] = "fi-fi";
    IconSymbol["LocaleFrCa"] = "fr-ca";
    IconSymbol["LocaleFrFr"] = "fr-fr";
    IconSymbol["LocaleGlEs"] = "gl-es";
    IconSymbol["LocaleHiIn"] = "hi-in";
    IconSymbol["LocaleHrHr"] = "hr-hr";
    IconSymbol["LocaleHuHu"] = "hu-hu";
    IconSymbol["LocaleInId"] = "in-id";
    IconSymbol["LocaleItIt"] = "it-it";
    IconSymbol["LocaleIwIl"] = "iw-il";
    IconSymbol["LocaleJaJp"] = "ja-jp";
    IconSymbol["LocaleKkKz"] = "kk-kz";
    IconSymbol["LocaleKoKr"] = "ko-kr";
    IconSymbol["LocaleLoLa"] = "lo-la";
    IconSymbol["LocaleLtLt"] = "lt-lt";
    IconSymbol["LocaleMsMy"] = "ms-my";
    IconSymbol["LocaleNbNo"] = "nb-no";
    IconSymbol["LocaleNlBe"] = "nl-be";
    IconSymbol["LocaleNlNl"] = "nl-nl";
    IconSymbol["LocalePlPl"] = "pl-pl";
    IconSymbol["LocalePtBr"] = "pt-br";
    IconSymbol["LocalePtPt"] = "pt-pt";
    IconSymbol["LocaleRoRo"] = "ro-ro";
    IconSymbol["LocaleRuRu"] = "ru-ru";
    IconSymbol["LocaleSkSk"] = "sk-sk";
    IconSymbol["LocaleSlSi"] = "sl-si";
    IconSymbol["LocaleSrRs"] = "sr-rs";
    IconSymbol["LocaleSrRsLatin"] = "sr-rs-latin";
    IconSymbol["LocaleSvSe"] = "sv-se";
    IconSymbol["LocaleTaIn"] = "ta-in";
    IconSymbol["LocaleThTh"] = "th-th";
    IconSymbol["LocaleTrTr"] = "tr-tr";
    IconSymbol["LocaleUkUa"] = "uk-ua";
    IconSymbol["LocaleUzUz"] = "uz-uz";
    IconSymbol["LocaleViVn"] = "vi-vn";
    IconSymbol["LocaleZhCn"] = "zh-cn";
    IconSymbol["LocaleZhTw"] = "zh-tw";
    IconSymbol["Lock"] = "lock";
    IconSymbol["LockDots"] = "lock-dots";
    IconSymbol["Logout"] = "logout";
    IconSymbol["LowVision"] = "low-vision";
    IconSymbol["Magic"] = "magic";
    IconSymbol["MagicStar"] = "magic-star";
    IconSymbol["MarkAsAnswer"] = "mark-as-answer";
    IconSymbol["MarkAsQuestion"] = "mark-as-question";
    IconSymbol["MegaphoneFull"] = "megaphone-full";
    IconSymbol["Merge"] = "merge";
    IconSymbol["Message"] = "message";
    IconSymbol["MessageBoards"] = "message-boards";
    IconSymbol["MinusCircle"] = "minus-circle";
    IconSymbol["MobileDeviceRules"] = "mobile-device-rules";
    IconSymbol["MobileLandscape"] = "mobile-landscape";
    IconSymbol["MobilePortrait"] = "mobile-portrait";
    IconSymbol["Moon"] = "moon";
    IconSymbol["Move"] = "move";
    IconSymbol["MoveFolder"] = "move-folder";
    IconSymbol["Myspace"] = "myspace";
    IconSymbol["Number"] = "number";
    IconSymbol["Oauth"] = "oauth";
    IconSymbol["OpenAllCollapse"] = "open-all-collapse";
    IconSymbol["OpenId"] = "open-id";
    IconSymbol["OrderArrow"] = "order-arrow";
    IconSymbol["OrderArrowDown"] = "order-arrow-down";
    IconSymbol["OrderArrowLeft"] = "order-arrow-left";
    IconSymbol["OrderArrowRight"] = "order-arrow-right";
    IconSymbol["OrderArrowUp"] = "order-arrow-up";
    IconSymbol["OrderListDown"] = "order-list-down";
    IconSymbol["OrderListUp"] = "order-list-up";
    IconSymbol["Organizations"] = "organizations";
    IconSymbol["Page"] = "page";
    IconSymbol["PagesTree"] = "pages-tree";
    IconSymbol["PageTemplate"] = "page-template";
    IconSymbol["Paperclip"] = "paperclip";
    IconSymbol["Paragraph"] = "paragraph";
    IconSymbol["PasswordPolicies"] = "password-policies";
    IconSymbol["Paste"] = "paste";
    IconSymbol["PastePlaintext"] = "paste-plaintext";
    IconSymbol["PasteWord"] = "paste-word";
    IconSymbol["Pause"] = "pause";
    IconSymbol["Pencil"] = "pencil";
    IconSymbol["Phone"] = "phone";
    IconSymbol["Picture"] = "picture";
    IconSymbol["Pin"] = "pin";
    IconSymbol["PinFull"] = "pin-full";
    IconSymbol["Play"] = "play";
    IconSymbol["Plug"] = "plug";
    IconSymbol["Plus"] = "plus";
    IconSymbol["PlusSquares"] = "plus-squares";
    IconSymbol["Polls"] = "polls";
    IconSymbol["Print"] = "print";
    IconSymbol["ProductMenu"] = "product-menu";
    IconSymbol["ProductMenuClosed"] = "product-menu-closed";
    IconSymbol["ProductMenuOpen"] = "product-menu-open";
    IconSymbol["Propagation"] = "propagation";
    IconSymbol["QuestionCircle"] = "question-circle";
    IconSymbol["QuestionCircleFull"] = "question-circle-full";
    IconSymbol["QuoteLeft"] = "quote-left";
    IconSymbol["QuoteRight"] = "quote-right";
    IconSymbol["RadioButton"] = "radio-button";
    IconSymbol["RatingBigStar"] = "rating-big-star";
    IconSymbol["React"] = "react";
    IconSymbol["Rectangle"] = "rectangle";
    IconSymbol["RectangleSplit"] = "rectangle-split";
    IconSymbol["Redo"] = "redo";
    IconSymbol["Relationship"] = "relationship";
    IconSymbol["Reload"] = "reload";
    IconSymbol["RemoveRole"] = "remove-role";
    IconSymbol["RemoveStyle"] = "remove-style";
    IconSymbol["Reply"] = "reply";
    IconSymbol["Repository"] = "repository";
    IconSymbol["Reset"] = "reset";
    IconSymbol["Restore"] = "restore";
    IconSymbol["Rotate"] = "rotate";
    IconSymbol["Rss"] = "rss";
    IconSymbol["RssFull"] = "rss-full";
    IconSymbol["Rules"] = "rules";
    IconSymbol["Search"] = "search";
    IconSymbol["SearchExperiences"] = "search-experiences";
    IconSymbol["SearchPlus"] = "search-plus";
    IconSymbol["Select"] = "select";
    IconSymbol["SelectAll"] = "select-all";
    IconSymbol["SelectFromList"] = "select-from-list";
    IconSymbol["Separator"] = "separator";
    IconSymbol["Share"] = "share";
    IconSymbol["ShareAlt"] = "share-alt";
    IconSymbol["Sheets"] = "sheets";
    IconSymbol["ShieldCheck"] = "shield-check";
    IconSymbol["ShoppingCart"] = "shopping-cart";
    IconSymbol["Shortcut"] = "shortcut";
    IconSymbol["Signature"] = "signature";
    IconSymbol["SignIn"] = "sign-in";
    IconSymbol["SimpleCircle"] = "simple-circle";
    IconSymbol["SimulationMenu"] = "simulation-menu";
    IconSymbol["SimulationMenuClosed"] = "simulation-menu-closed";
    IconSymbol["SimulationMenuOpen"] = "simulation-menu-open";
    IconSymbol["Sites"] = "sites";
    IconSymbol["SiteTemplate"] = "site-template";
    IconSymbol["Slideshow"] = "slideshow";
    IconSymbol["Sms"] = "sms";
    IconSymbol["SocialFacebook"] = "social-facebook";
    IconSymbol["SocialInstagram"] = "social-instagram";
    IconSymbol["SocialLinkedin"] = "social-linkedin";
    IconSymbol["SocialTwitter"] = "social-twitter";
    IconSymbol["SocialVimeo"] = "social-vimeo";
    IconSymbol["Spacer"] = "spacer";
    IconSymbol["SpecialCharacter"] = "special-character";
    IconSymbol["Square"] = "square";
    IconSymbol["SquareHole"] = "square-hole";
    IconSymbol["SquareHoleMulti"] = "square-hole-multi";
    IconSymbol["Staging"] = "staging";
    IconSymbol["Star"] = "star";
    IconSymbol["StarHalf"] = "star-half";
    IconSymbol["StarO"] = "star-o";
    IconSymbol["Sticky"] = "sticky";
    IconSymbol["Strikethrough"] = "strikethrough";
    IconSymbol["Subscript"] = "subscript";
    IconSymbol["Suitcase"] = "suitcase";
    IconSymbol["Sun"] = "sun";
    IconSymbol["Superscript"] = "superscript";
    IconSymbol["Table"] = "table";
    IconSymbol["Table2"] = "table2";
    IconSymbol["TabletLandscape"] = "tablet-landscape";
    IconSymbol["TabletPortrait"] = "tablet-portrait";
    IconSymbol["Tabs"] = "tabs";
    IconSymbol["Tag"] = "tag";
    IconSymbol["TapAhead"] = "tap-ahead";
    IconSymbol["Telegram"] = "telegram";
    IconSymbol["Test"] = "test";
    IconSymbol["Text"] = "text";
    IconSymbol["Textbox"] = "textbox";
    IconSymbol["TextColor"] = "text-color";
    IconSymbol["TextEditor"] = "text-editor";
    IconSymbol["TextL"] = "text-l";
    IconSymbol["Theme"] = "theme";
    IconSymbol["ThirdParty"] = "third-party";
    IconSymbol["ThumbsDown"] = "thumbs-down";
    IconSymbol["ThumbsDownFull"] = "thumbs-down-full";
    IconSymbol["ThumbsUp"] = "thumbs-up";
    IconSymbol["ThumbsUpArrow"] = "thumbs-up-arrow";
    IconSymbol["ThumbsUpFull"] = "thumbs-up-full";
    IconSymbol["Time"] = "time";
    IconSymbol["Times"] = "times";
    IconSymbol["TimesCircle"] = "times-circle";
    IconSymbol["TimesCircleFull"] = "times-circle-full";
    IconSymbol["TimesSmall"] = "times-small";
    IconSymbol["Transform"] = "transform";
    IconSymbol["Trash"] = "trash";
    IconSymbol["Truck"] = "truck";
    IconSymbol["Twitter"] = "twitter";
    IconSymbol["Underline"] = "underline";
    IconSymbol["Undo"] = "undo";
    IconSymbol["Unlock"] = "unlock";
    IconSymbol["Unpin"] = "unpin";
    IconSymbol["Upload"] = "upload";
    IconSymbol["UploadMultiple"] = "upload-multiple";
    IconSymbol["Urgent"] = "urgent";
    IconSymbol["User"] = "user";
    IconSymbol["UserPlus"] = "user-plus";
    IconSymbol["Users"] = "users";
    IconSymbol["VerticalScroll"] = "vertical-scroll";
    IconSymbol["Video"] = "video";
    IconSymbol["View"] = "view";
    IconSymbol["Vocabulary"] = "vocabulary";
    IconSymbol["Warning"] = "warning";
    IconSymbol["WarningFull"] = "warning-full";
    IconSymbol["WebContent"] = "web-content";
    IconSymbol["Wiki"] = "wiki";
    IconSymbol["WikiPage"] = "wiki-page";
    IconSymbol["Workflow"] = "workflow";
})(IconSymbol || (IconSymbol = {}));
exports.default = IconSymbol;
//# sourceMappingURL=IconSymbol.js.map